import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    list: []
  }),
  actions: {
    getScents({ commit, state }, answers) {
      return new Promise((resolve, reject) => {
        axios
          .get(process.env.VUE_APP_CMS_API_URL + 'scents', {
            headers: {
              'Accept-Language': 'nl',
            },
          })
          .then((resp) => {
            commit(`setScents`, resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            console.warn(err);
            reject(err);
          });
      });
    },
  },
  mutations: {
    setScents(state, data) {
      if (data.length) {
        state.list = data;
      }
    }
  },
  getters: {
    getScent: (state) => (id) => {
      return state.list.filter((scent) => {
        return scent.id === id;
      })
    },
    getScentsById: (state) => (ids) => {
      return state.list.filter((scent) => {
        return ids.includes(scent.id)
      })
    },
    getScentNameById: (state) => (id) => {
      return state.list.find(scent => scent.id == id).title;
    }
  }
};
